var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "auth-form", width: 0 },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal modal__400 modal__login show outside-click-exclude",
          attrs: { id: "login_modal" }
        },
        [
          _c(
            "section",
            [
              _c(
                "a",
                { staticClass: "modal__close", on: { click: _vm.hide } },
                [_c("i", { staticClass: "icon-close" })]
              ),
              _vm._v(" "),
              _vm.show === "login" ? _c("Login") : _vm._e(),
              _vm._v(" "),
              _vm.show === "forgot"
                ? _c("ForgotPass", {
                    attrs: { "expired-message": _vm.expiredMessage }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }